// removed by extract-text-webpack-plugin
module.exports = {"robotics-section":"_3mbZECnO","roboticsSection":"_3mbZECnO","learn-more":"_3Gxcxqdv","learnMore":"_3Gxcxqdv","button":"_2BySs9VU","content":"OqU2tXYc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RoboticsSection/RoboticsSection.pcss
// module id = 404
// module chunks = 0